import React from "react";

/**
 * Shorten text to max length. Show popup on hover(not impl). Ellipsis counts towards max
 */
export default function ShortText({ text, maxLength = 10 }: { text?: string, maxLength?: number}) {
    if (!text) return null;

    const usedText = text.length > maxLength ? `${text.substring(0, maxLength - 3)}...` : text

    return <span>{usedText}</span>
}